// localStorage.debug='*';

import Cookies from 'js-cookie';

import { Manager } from "socket.io-client";


import EventEmitter from "wolfy87-eventemitter";

const READ = "READ";
const WRITE = "WRITE";
const SWITCHON = "SWITCHON";
const SWITCHOFF = "SWITCHOFF";

// Promise.onPossiblyUnhandledRejection(function(error) {
//     throw error;
// });


const ERROR_NOT_AUTH = "not_auth";

function Push() {
    const notifyUpdatePath = function (subStore, parts, index, value, lastValue, path) {
        const part = parts[index];
        let sub = undefined;
        if (!subStore) {
            return false;
        }
        sub = subStore[part];

        const implodeEnd = function () {
            let ret = "";
            for (let i = index; i < parts.length; i++) {
                if (parts[i] && parts[i] !== "") {
                    ret += (i !== index ? "/" : "") + parts[i];
                }
            }
            return ret;
        };

        const notifyDirectSubs = function (lastRetained) {
            if (sub && sub.__list) {
                for (let i in sub.__list) {
                    const subCb = sub.__list[i];
                    subCb(value, lastRetained, "", parts[parts.length - 1],
                        path);
                }
            }
            if (subStore["+"]) {
                const plusSubList = subStore["+"].__list;
                if (!plusSubList) {
                    return;
                }
                for (let i in plusSubList) {
                    const plusSub = plusSubList[i];
                    if (_debugUpdates) {
                        console.log(
                            "3Notifying plus sub for path " + implodeEnd(),
                            plusSub, value);
                    }
                    plusSub(value, retainedObj, implodeEnd(),
                        parts[parts.length - 1], path);
                }
            }
        };

        if (sub) {
            if (index === parts.length - 1) {
                notifyDirectSubs(lastValue);
                return true;
            } else {
                notifyUpdatePath(sub, parts, index+1, value, lastValue, path);
            }
        }

        if (subStore["*"]) {
            const starSubList = subStore["*"].__list;
            for (let i in starSubList) {
                const starSub = starSubList[i];
                starSub(value, retainedObj, implodeEnd(), parts[parts.length - 1], path);
            }
        }
        if (subStore["+"]) {
            for (let i in subStore["*"]) {
                const plusSub = subStore["*"][i];
                if (_debugUpdates) {
                    console.log("4Notifying plus sub for path " + parts.slice(0, index).join("/"), plusSub, value);
                }
                // plusSub(value, retainedObj, implodeEnd(), parts[parts.length - 1], path);
                notifyUpdatePath (plusSub, parts, index+1, value, retainedObj, path);
            }
        }
    };
    Object.assign(Push.prototype, EventEmitter.prototype);
    const _debugUpdates = false;
    const DEBUG = false;
    let _subs = {},
        _ds = {};
    const   _unchanged = "__UNCHANGED__";
    let _serverSubs = {};

    const ALL_RULES = [READ, WRITE];
    let  _socket = null,
        _connected = false,
        _username = null,
        _sessionId = Cookies.get('om_session'),
        // _sessionId = null,
        _roles = [],
        _rules = [],
        _notificationListeners = new Set();

    class Subscription {

        _promises = [];
        _dsCB = [];
        topic = null;
        isActive = false;

        constructor(topic, fulfill, reject) {
            this.topic = topic;
            this.addPromise(fulfill, reject);
        }

        addPromise(fulfill, reject) {
            if (this.isActive) {
                throw "Why add when active";
            }
            this._promises.push({fulfill, reject});
        }

        fulfill(res) {
            for (let i in this._promises) {
                this._promises[i].fulfill(res);
            }
            this._promises = [];
        }

        reject(res) {
            for (let i in this._promises) {
                if (this._promises[i].reject) {
                    this._promises[i].reject(res);
                }
            }
            this._promises = [];
        }

        subscribeDS(push, cb, callInitial) {
            const self = this;

            const sub = push.subscribeDS(this.topic, cb);
            this._dsCB.push(sub);

            // Create the function that the caller can use to unsubscribe
            function unsubscribe() {
                // Definitely unsubscribe the user-supplied callback from DS updates so we don't
                // have hanging references
                push.unsubscribeDS(cb, sub);
                // Remove from list of subscriptions
                self._dsCB.splice(self._dsCB.indexOf(sub), 1);

                // Now if this was the last subscription to there, unsubscribe from 
                if (self._dsCB.length === 0) {
                    push.unsubscribePush(self.topic);
                }
            }

            if (callInitial) {
                window.setTimeout(function() {
                    const data = push.getPath(self.topic);
                    cb(data, data, "", self.topic, self.topic);
                }, 0);
            }

            return unsubscribe;
        }
    }

    const setOrCreatePath = function (ds, subStore, parts, index, value, path,
        noNotify, alwaysExtend) {
        const part = parts[index];
        let retainedObj, sub;
        if (!part || part === "") {
            retainedObj = ds;
        } else {
            retainedObj = ds[part];
        }
        if (subStore != null) {
            sub = subStore[part];
        }

        const implodeEnd = function () {
            let ret = "";
            for (let i = index; i < parts.length; i++) {
                if (parts[i] && parts[i] !== "") {
                    ret += (i !== index ? "/" : "") + parts[i];
                }
            }
            return ret;
        };

        const notifyDirectSubs = function (lastRetained) {
            let i;
            if (sub && sub.__list) {
                for (i in sub.__list) {
                    const subCb = sub.__list[i];
                    subCb(value, lastRetained, "", parts[parts.length - 1],
                        path);
                }
            }
            if (subStore && subStore["+"]) {
                var plusSubList = subStore["+"].__list;
                if (!plusSubList) {
                    return;
                }
                for (i in plusSubList) {
                    let plusSub = plusSubList[i];
                    if (_debugUpdates) {
                        console.log(
                            "1Notifying plus sub for path " + implodeEnd(),
                            plusSub, value);
                    }
                    plusSub(value, retainedObj, implodeEnd(),
                        parts[parts.length - 1], path);
                }
            }

            if (subStore && subStore["*"]) {
                let plusSubList = subStore["*"].__list;
                if (!plusSubList) {
                    return;
                }
                for (i in plusSubList) {
                    var plusSub = plusSubList[i];
                    if (_debugUpdates) {
                        console.log(
                            "1Notifying star sub for path " + implodeEnd(),
                            plusSub, value);
                    }
                    plusSub(value, retainedObj, implodeEnd(),
                        parts[parts.length - 1], path);
                }
            }
        };

        if (retainedObj === undefined || retainedObj === null) {
            // The container was not already in the datastore
            if (index === parts.length - 1) {
                // We are at the end, we won't create a container
                ds[part] = value;
                if (!noNotify) {
                    notifyDirectSubs(retainedObj);
                }
                return ds[part];
            } else {
                ds[part] = {};
                retainedObj = ds[part];
            }
        } else {
            // The container was already there
            if (index === parts.length - 1) {
                if (retainedObj === value) {
                    return _unchanged;
                }
                // If we are silently updating the Datastore, we can overwrite complete objects
                if (noNotify) {
                    if (part && part !== "") {
                        ds[part] = value;
                    }
                } else {
                    // If a null value has been pushed, we will delete the whole branch in DS.
                    // TODO: maybe this should propagate and tell all subpaths?
                    if (value === null) {
                        if (part && part !== "") {
                            delete (ds[part]);
                        }
                        retainedObj = null;
                    } else {
                        if (value.ts && retainedObj.ts && retainedObj.ts
                            > value.ts) {
                            if (_debugUpdates) {
                                console.warn("Not updating path " + path
                                    + " with outdated object", value,
                                    retainedObj);
                            }
                            return _unchanged;
                        }
                        // Don't overwrite this if it has more than two keys (v and ts)
                        if (!alwaysExtend && part && part != "" && Object.keys(
                                retainedObj).length == 2 && "ts" in retainedObj
                            && "v" in retainedObj) {
                            ds[part] = value;
                        } else {
                            Object.assign(retainedObj, value);
                            // Take special care to reset new if it has been zeroed
                            if (value.new === undefined || value.new === null) {
                                if (retainedObj.new) {
                                    retainedObj.new = null;
                                }
                            }
                            //$.extend(true, retainedObj, value);
                        }
                    }
                    notifyDirectSubs(retainedObj);
                }
                return retainedObj;
            }
        }

        retainedObj = setOrCreatePath(retainedObj, sub, parts, index + 1, value,
            path, noNotify, alwaysExtend);

        if (retainedObj === _unchanged || noNotify) {
            return;
        }

        if (subStore != null) {
            if (subStore["*"]) {
                const starSubList = subStore["*"].__list;
                for (let i in starSubList) {
                    const starSub = starSubList[i];
                    starSub(value, retainedObj, implodeEnd(),
                        parts[parts.length - 1], path);
                }
            }
            if (subStore["+"]) {
                notifyUpdatePath(subStore["+"], parts, index + 1, value,
                    retainedObj, path);
                /* const plusSubList = subStore["+"].__list;
                if (plusSubList) {
                    for (var i in plusSubList) {
                        var plusSub = plusSubList[i];
                        if (_debugUpdates) {
                            console.log("2Notifying plus sub for path " + parts.slice(0, index).join("/"), plusSub, value);
                        }
                        notifyUpdatePath (plusSub, parts, index+1, value, retainedObj, path);
                    }
                } */
            }
        }
    };

    const createSubscriptionInt = function (subStore, parts, index, subCb, path) {
        let part = parts[index];
        let sub;

        // TODO: Detect when we enter a path that has subscriptions already and then don't subscribe this from Push

        if (part === "*") {
            if (index !== parts.length - 1) {
                // Wildcard can only be at last place
                throw new Error("Wildcard token can only be the last path element '" + path + "'");
            }
        }
        sub = subStore[part];

        if (!sub) {
            sub = { '__list':[] };
            subStore[part] = sub;
        }

        if (parts.length -1 === index) {
            // We're at the last path element. Check if the subscription is already in the list
            if (sub.__list) {
                if (sub.__list.indexOf(subCb) !== -1) {
                    // This subscription is already there, we're done
                    return sub;
                }
                sub.__list.push(subCb);
                return sub;
            } else {
                sub.__list = [subCb];
                return sub;
            }
        } else {
            // The path goes on. Call self recursively with the next path index
            return createSubscriptionInt(sub, parts, index+1, subCb, path);
        }
    };

    const deleteSubscription = function (subCb, subObject) {
        // TODO: Go up chain and clean up
        if (subObject) {
            const index = subObject.__list.indexOf(subCb);
            if (index === -1) {
                return false;
            }
            subObject.__list.splice(index, 1);
            return true;
        }
        return false;
    };

    const createSubscription = function (path, subCb) {
        while (path.slice(-1) === '/') {
            path = path.slice(0, -1);
        }
        const parts = path.split("/");
        return createSubscriptionInt(_subs, parts, 0, subCb, path);
    };

    this.getPath = function (path) {
        while(path.slice(-1) === '/') {
            path = path.slice(0, -1);
        }
        let parts = path.split("/");

        let ds = _ds;
        for (let i in parts) {
            let part = parts[i];

            if (ds[part]) {
                ds = ds[part];
            } else {
                return null;
            }
        }

        return ds;
    };

    const getPathCbInt = function (ds, parts, index, cb, incompletePath) {
        // 
        let part = parts[index];

        if (part === "+") {
            for (let key in ds) {
                let thisPath = incompletePath ? incompletePath + "/" + key : key;
                getPathCbInt(ds[key], parts, index+1, cb, thisPath);
            }
            return;
        }

        const obj = ds[part];
        if (obj) {
            index++;
            let thisPath = incompletePath ? incompletePath + "/" + part : part;
            if (index >= parts.length) {
                cb(obj, thisPath);
            } else {
                getPathCbInt(obj, parts, index, cb, thisPath);
            }
        }
    };

    const storePermissions = function (permissions) {
        // Permissions are transmitted as an array of arrays of the following form:
        // [IS_ALLOW, OPERATION, REGEX]
        // IS_ALLOW = Bool, if false a match must lead to aborting the parsing and failing the permission check
        // OPERATION = String, operation like "READ", "WRITE"
        // REGEX = String, pattern matching the DS path
        // The order of operations is important and needs to be maintained

        const rules = {};

        const addRule = function(regex, isAllowed, operation) {
            let opRules = rules[operation];
            if (opRules === undefined) {
                opRules = [];
                rules[operation] = opRules;
            }
            opRules.push([isAllowed, regex]);
        };

        for (let i in permissions) {
            const rule = permissions[i];
            const operation = rule[1];
            // Precompile regex
            const regex = new RegExp(rule[2]);

            if (operation) {
                addRule(regex, rule[0], operation);
            } else {
                // If no operation was set this applies to all operations
                for (let k in ALL_RULES) {
                    addRule(regex, rule[0], ALL_RULES[k]);
                }
            }
        }

        return rules;
    };

    this.getPathCb = function (path, cb) {
        const parts = path.split("/");

        getPathCbInt(_ds, parts, 0, cb, "");
    };

    const getPathListInt = function (ds, parts, index, list, incompletePath) {
        // 
        let part = parts[index];

        if (part === "+") {
            for (let key in ds) {
                let thisPath = incompletePath ? incompletePath + "/" + key : key;
                getPathListInt(ds[key], parts, index+1, list, thisPath);
            }
            return;
        }

        const obj = ds[part];
        if (obj) {
            index++;
            let thisPath = incompletePath ? incompletePath + "/" + part : part;
            if (index >= parts.length) {
                list[thisPath] = obj;
            } else {
                getPathListInt(obj, parts, index, list, thisPath);
            }
        }
    };

    this.getPathList = function (path) {
        const parts = path.split("/");
        const list = [];

        getPathListInt(_ds, parts, 0, list, "");
        return list;
    };

    this.getDeviceIdFromPath = function(path) {
        path = path.substring(7);
        const i = path.indexOf("/");
        return path.substring(0, i);
    };

    this.getLocalSubState = function() {
        const out = {};
        const recurse = function (subStore, subPath) {
            for (let i in subStore) {
                if (subStore.hasOwnProperty(i)) {
                    if (i === "__list" && subStore[i].length) {
                        out[subPath] = subStore[i];
                    } else {
                        recurse (subStore[i], subPath + "/" + i);
                    }
                }
            }
        };
        recurse(_subs, "");
        return out;
    };

    this.subscribeDS = createSubscription;

    this.unsubscribeDS =  deleteSubscription;

    this.subs = _subs;

    const setPath = function(path, value, noNotify) {
        const parts = path.split("/");
        if (DEBUG) { console.log("setPath", path, value); }
        setOrCreatePath(_ds, _subs, parts, 0, value, path, noNotify);
    };

    const extendPath = function(path, value) {
        const parts = path.split("/");
        if (DEBUG) { console.log("extendPath", path, value); }
        setOrCreatePath(_ds, _subs, parts, 0, value, path, false, true);
    };

    this.testStuff = function(testFunction) {
        testFunction(setPath);
    };

    let hostname;

    const self = this;

    if ('overrideServer' in window) {
        hostname = window.overrideServer;
    } else {
        hostname = window.location.origin;
    }

    if (!hostname.endsWith('/')) {
        hostname = hostname + '/';
    }

    const socketIoManager = new Manager(hostname, {
        reconnectionDelayMax: 4000,
    });

    const createIoSocket = function() {
        const newSocketClient = socketIoManager.socket("/", {
            "timeout": 4000,
            auth: (cb) => {
                if (!_sessionId) {
                    cb();
                } else {
                    cb({ token: _sessionId })
                }
            }
        });

        newSocketClient.on("upw", function (data) {
            if (_debugUpdates) {
                console.info("update wildcard", data);
            }
            if (data.sub) {
                if (data.t) {
                    setPath(data.sub + "/" + data.t, data.d);
                } else {
                    setPath(data.sub, data.d);
                }
            } else {
                setPath(data.t, data.d);
            }
        });

        newSocketClient.on("exw", function (timestamp, path) {
            if (DEBUG) { console.log("exw", timestamp, path); }
            extendPath(path, {"tsLast": timestamp});
        });

        newSocketClient.on("ex", function (timestamp, path) {
            if (DEBUG) { console.log("ex", timestamp, path); }
            extendPath(path, {"tsLast": timestamp});
        });

        newSocketClient.on("up", function (data) {
            if (_debugUpdates) {
                console.info("update", data);
            }
            if (data.sub) {
                setPath(data.sub, data.d);
            }
        });

        newSocketClient.on("expired", function() {
            console.log("closeSession successful");
            self.closeSession("expired");
            self.emitEvent("not_authenticated", []);
            newSocketClient.disconnect();
            _socket = createIoSocket();
        });

        newSocketClient.on("session", (result) => {
            console.log("Session ok");
            _sessionId = result.sessionId;
            _roles = result.roles;
            _username = result.username;
            _rules = storePermissions(result.permissions);
            Cookies.set('om_session', _sessionId);

            window.setTimeout(() => {
                self.emitEvent("authenticated", [_username, _roles, _rules]);
            }, 0);
        });

        newSocketClient.on("connect", function () {
            _connected = true;
            if (!_sessionId) {
                console.log('connected without session, not authenticated');
                self.emitEvent("not_authenticated");
            }
            console.info("Connect");
            self.emitEvent("connect");
        });

        newSocketClient.on("disconnect", function (reason) {
            _connected = false;
            console.warn("Disconnect");
            resetDS();
            self.emitEvent("disconnect");
            if (reason === "io server disconnect" || reason === "io client disconnect") {
                setTimeout(() => {
                    // the disconnection was initiated by the server, you need to reconnect manually
                    _socket = createIoSocket();
                }, 500);
            }
        });

        newSocketClient.on("connect_error", function (err) {
            _connected = false;
            console.warn("Connect Error", err, err.code);
            if (err.message.indexOf("session") !== -1 || err.message.indexOf('token') !== -1) {
                console.log("Session invalid");
                _sessionId = null;
                Cookies.remove('om_session');
                self.emitEvent("not_authenticated", [ err.code ]);
                setTimeout(() => {
                    console.log('reconnecting');
                    // the disconnection was initiated by the server, you need to reconnect manually
                    newSocketClient.disconnect();
                    _socket = createIoSocket();
                }, 500);
            }
            self.emitEvent("disconnect");
        });

        return newSocketClient;
    };

    _socket = createIoSocket();

    this.isAuthenticated = function () {
        return _sessionId != null;
    };

    this.isConnected = function () {
        return _connected;
    };

    this.onAuthenticated = function (cb) {
        if (this.isAuthenticated()) {
            cb(_username, _roles, _rules);
        } else {
            const _internalCb = function (username, roles) {
                cb(username, roles);
                // Only call the callback once
                this.removeListener("authenticated", _internalCb);
            };
            this.addListener("authenticated", _internalCb);
        }
    };

    this.hasSessionId = function () {
        return _sessionId != null;
    };

    this.checkPermission = function(operation, path) {
        const rules = _rules[operation];

        for (let i in rules) {
            const rule = rules[i];
            if (rule[1].test(path)) {
                // Path matches regex, now check if allow
                if (rule[0]) {
                    return true;
                } else {
                    return false;
                }
            }
        }

        return false;
    };

    const resetDS = () => {
        // We will only keep status/omshepherd, as that is subscribable anyway
        let shepherdStatus = _ds && _ds.status && _ds.status.omshepherd;
        if (shepherdStatus) {
            _ds = {
                "status": {
                    "omshepherd": shepherdStatus
                }
            };
        } else {
            _ds = {};
        }
        self.DS = _ds;
        _serverSubs = [];
    }

    this.closeSession = function (reason) {
        const self = this;
        let killSessionTimeout;
        let killSessionCB = function () {
            if (!killSessionTimeout) {
                // Session was already killed
                return;
            }
            if (killSessionTimeout) {
                window.clearTimeout(killSessionTimeout);
            }
            killSessionTimeout = 0;
            resetDS();
            _sessionId = null;
            Cookies.remove('om_session');
            self.emitEvent("not_authenticated");
        };
        killSessionTimeout = setTimeout(killSessionCB, 1000);
        try {
            _socket.emit("logout", {reason:reason, user:_username}, function (result) {
                console.log("closeSession successful");
                killSessionCB();
            });
        } catch (e) {
            killSessionCB();
        }
    };

    /**
     * Subscribe to a topic on the server and then get notified of updates. This is internally
     * a combination of subscribePush and subscribeDS but will avoid subscribing twice to the
     * same path on the server (which is a no-op but will take time).
     * 
     * @param topic: the topic to subscribe to
     * @param cb: the cb to call
     * @param callInitial: if true, call cb also after the initial subscribe with the initial data
     * @returns a Promise that will get a function that can be executed to unsubscribe
     */
    this.subscribe = function(topic, cb, callInitial) {
        const self = this;
        return new Promise(function (fulfill, reject) {
            // SubscribePush ensures that we do not subscribe multiple times
            self.subscribePush(topic).then(function(result, error) {
                if (error) {
                    reject(new Error(error));
                } else {
                    // The subscribe action succeeded, now subscribe to the local DS
                    fulfill(_serverSubs[topic].subscribeDS(self, cb, callInitial));
                }
            });
        });
    };

    this.subscribePush = function(inputPath, updateSeparateOmData) {
        const self = this;
        return new Promise(function (fulfill, reject) {
            if (_serverSubs[inputPath] !== undefined) {
                // This topic is known. Check if it is subscribed or we are still waiting for the subscribe
                if (_serverSubs[inputPath].isActive) {
                    // We are already subscribed, fulfill right away
                    fulfill(self.getPath(inputPath));
                } else {
                    // No, we are waiting for the subscribe action, add this promise to the others
                    _serverSubs[inputPath].addPromise(fulfill, reject);
                }
                return;
            }
            const sub = new Subscription(inputPath, fulfill, reject);
            _serverSubs[inputPath] = sub;
            try {
                _socket.emit("sub", inputPath, function (rawResult) {
                    const result = typeof rawResult === 'string' ? JSON.parse(rawResult) : rawResult;
                    if (result?.error) {
                        if (result?.error === ERROR_NOT_AUTH) {
                            self.closeSession("expired");
                        }
                        console.info("subscribePush not allowed", inputPath, result?.error);
                        sub.reject(new Error(result?.error));
                        sub.isActive = false;
                        _serverSubs[inputPath] = undefined;
                        return;
                    }

                    sub.isActive = true;

                    // Go over inputPath and multiply out + and * into different set commands...
                    let obj;

                    if (result.relativePath) {
                        const relativePath = result.relativePath;
                        delete result.relativePath;
                        setPath(relativePath, result);
                        sub.fulfill(obj);
                        return;
                    }

                    const pathParts = inputPath.split("/");

                    const resolve = function (pathParts, i, updatePath, updateObj) {
                        if (!updateObj) {
                            return;
                        }
                        const part = pathParts[i];
                        const isLast = i === pathParts.length;
                        if (part === "+") {
                            for (const subPath in updateObj) {
                                if (updateObj.hasOwnProperty(subPath)) {
                                    const subUpdatePath = (updatePath === "" ? subPath : updatePath + "/" + subPath);
                                    if (isLast) {
                                        setPath(subUpdatePath, updateObj[subPath]);
                                    } else {
                                        resolve(pathParts, i+1, subUpdatePath, updateObj[subPath]);
                                    }
                                }
                            }
                        } else if (part === "*") {
                            setPath(updatePath, updateObj);
                        } else {
                            if (isLast) {
                                setPath(updatePath, updateObj);
                            } else {
                                resolve(pathParts, i+1, (updatePath === "" ? part : updatePath + "/" + part), updateObj[part]);
                            }
                        }
                    };
                    resolve(pathParts, 0, "", result);

                    sub.fulfill(obj);
                });
            } catch (ex) {
                sub.reject(ex);
                sub.isActive = false;
                _serverSubs[inputPath] = undefined;
            }
        });
    };

    this.unsubscribePush = function(path) {
        const sub = _serverSubs[path];
        if (sub) {
            sub.isActive = false;
            _serverSubs[path] = undefined;
        }

        return new Promise(function (fulfill, reject) {
            try {
                _socket.emit("unsub", path, function (result, error) {
                    if (sub) {
                        // Reject pending subscribers without exception
                        sub.reject(new Error("unsubscribing"));
                    }
                    if (!result) {
                        if (error === ERROR_NOT_AUTH) {
                            self.closeSession("expired");
                        }
                        reject(new Error(error));
                    } else {
                        fulfill(result);
                    }
                });
            } catch (ex) {
                reject(ex);
            }
        });
    };

    this.getSubscriberState = function() {
        return new Promise(function (fulfill, reject) {
            try {
                _socket.emit("substate", "", function (result, error) {
                    if (!result) {
                        reject(new Error(error));
                    } else {
                        fulfill(result);
                    }
                });
            } catch (ex) {
                reject(ex);
            }
        });
    };

    this.hasRole = function(role) {
        return (_roles && _roles.indexOf(role) >= 0);
    };

    /**
     * put a value into the remote datastore
     * @param path the path to write to
     * @param value the value to write
     * @param createIfNecessary if true will allow the remote DS to create the value if it doesn't exist
     * @returns the result of the creation, will often be value itself
     */
    this.put = function (path, value, createIfNecessary) {
        const cmd = {
            'path': path,
            'value': value
        };
        return new Promise(function (fulfill, reject) {
            _socket.emit(createIfNecessary ? "write" : "put", cmd, function ({ error, result}) {
                if (error) {
                    if (error === ERROR_NOT_AUTH) {
                        self.closeSession("expired");
                    }
                    reject(new Error(error));
                } else {
                    try {
                        fulfill(result);
                    } catch (ex) {
                        reject(ex);
                    }
                }
            });
        });
    };

    this.write = function (path, value) {
        const cmd = {
            'path': path,
            'value': value
        };
        return new Promise(function (fulfill, reject) {
            _socket.emit("write", cmd, function ({ error }) {
                if (error) {
                    if (error === ERROR_NOT_AUTH) {
                        self.closeSession("expired");
                    }
                    reject(new Error(error));
                } else {
                    try {
                        fulfill();
                    } catch (ex) {
                        reject(ex);
                    }
                }
            });
        });
    };


    this.auth = function (username, password, useTimeout) {
        const cmd = {
                'username': username,
                'password': password,
                'useTimeout': useTimeout
            }, self = this;
        return new Promise(function (fulfill, reject) {
            _socket.emit("auth", cmd, function (result, error) {
                if (error) {
                    reject(new Error(error));
                } else {
                    _sessionId = result.sessionId;
                    _roles = result.roles;
                    _username = result.username;
                    _rules = storePermissions(result.permissions);
                    Cookies.set('om_session', _sessionId);

                    self.emitEvent("authenticated", [_username, _roles, _rules]);
                    fulfill();
                }
            });
        });
    };

    this.setPath = setPath;

    const _notificationSort = function (a, b) {
        return b.dateCreated - a.dateCreated;
    };

    this.drawSparkline = function (cb, path, $chartEl, seconds, resolution, fgColor) {
        const self = this;

        try {
            self.getHistorySeconds(path, seconds, resolution).then(function (result) {
                let history;
                if (typeof result === 'object') {
                    if (result.error) {
                        console.warn("drawSparkline", result.error);
                        return;
                    }
                    history = result;
                } else {
                    history = JSON.parse(result);
                }
                if (history.data.length === 0) {
                    console.log("Empty history for path", path);
                    return;
                }
                if (history.data.length === 1) {
                    history.data[1] = [ history.data[0][0], history.data[0][1] ];
                    history.data[1][0] = +Date.now();
                }
                const lastTS = history.data[history.data.length - 1][0];
                const options = {
                    grid: {show: false, labelMargin: 0, backgroundColor: null},
                    lines: {show: true, lineWidth: 2, fill: 0.3, zero: false},
                    xaxis: {
                        show: false,
                        min: lastTS - (seconds * 1000),
                        max: lastTS
                    },
                    yaxis: {show: false, autoScaleMargin: 0.08}
                };
                const data = {
                    color: fgColor,
                    clickable: false,
                    data: history.data,
                    hoverable: false,
                    shadowSize: 0
                };
                const plot = $chartEl.plot([data], options).data("plot");
                if (cb != null) {
                    cb (plot, data);
                }
            }).catch(function (err) {
                console.warn("drawSparkline", err);
            });
        } catch (e) {
            console.warn("drawSparkline", e);
        }
    };


    this.getHistory = function (path, size, resolution) {
        if (!resolution) {
            resolution = 5;
        }
        return new Promise(function (fulfill, reject) {
            _socket.emit("hist", {path: path, size: size, res: resolution}, function ({ error, ...result }) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        const histObj = JSON.parse(result);
                        if (histObj.data[0]) {
                            histObj.data[0][0] = (histObj.data[0][0] + histObj.ts) * resolution * 1000;

                            for (let i = 1; i < histObj.data.length; i++) {
                                histObj.data[i][0] = (histObj.data[i][0] * resolution * 1000 ) + histObj.data[i-1][0];
                            }
                        }
                        fulfill(histObj);
                    } catch (ex) {
                        reject(ex);
                    }
                }
            });
        });
    };

    this.getHistorySeconds = function (path, seconds, resolution) {
        if (!resolution) {
            resolution = 5;
        }
        return new Promise(function (fulfill, reject) {
            _socket.emit("hiss", {path: path, size: seconds, res: resolution}, function (result) {
                let histObj;
                if (typeof result === 'object') {
                    if (result.error) {
                        console.warn("drawSparkline", result.error);
                        return;
                    }
                    histObj = result;
                } else {
                    histObj = JSON.parse(result);
                }
                let nextTimeSlice, lastTimeSlice;
                try {
                    // TS C O H L
                    const timeStart = Date.now() - (seconds * 1000);
                    let i;

                    if (histObj.data[0]) {
                        lastTimeSlice = histObj.data[0][0] + histObj.ts;
                        histObj.data[0][0] = (histObj.data[0][0] + histObj.ts) * resolution * 1000;
                        histObj.data[0].splice(1, 0, histObj.data[0][1]);
                        histObj.data[0][5] = 0;

                        for (i = 1; i < histObj.data.length; i++) {
                            histObj.data[i][0] = (histObj.data[i][0] * resolution * 1000 ) + histObj.data[i-1][0];
                            histObj.data[i].splice(1, 0, histObj.data[i][1]);
                            histObj.data[i][5] = 0;

                            lastTimeSlice = histObj.data[i][0] / resolution / 1000;
                        }
                        let stripped = false, done = false;
                        for (i = histObj.data.length - 1; i >= 0; i--) {
                            if (histObj.data[i][0] < timeStart) {
                                // console.log("Dropping slice " + i  + " because its time is lower than timeStart (" + timeStart + ")", histObj.data[i][0]);
                                histObj.data[i][0] = timeStart;
                                done = true;
                            }

                            if (i > 0) {
                                if (histObj.data[i-1][0] < timeStart) {
                                    nextTimeSlice = Math.floor(timeStart / resolution / 1000);
                                } else {
                                    nextTimeSlice = histObj.data[i - 1][0] / resolution / 1000;
                                }

                                let thisTimeSlice = histObj.data[i][0] / resolution / 1000;
                                // console.log("Inspecting slice " + i + " for holes. ", thisTimeSlice, nextTimeSlice + 1, histObj.length);
                                while (thisTimeSlice > nextTimeSlice + 1) {
                                    thisTimeSlice--;
                                    const lastItem = histObj.data[i-1];
                                    const newItem = [thisTimeSlice * resolution * 1000, lastItem[1], lastItem[2], lastItem[3], lastItem[4], 1];
                                    histObj.data.splice(i, 0, newItem);
                                }
                                // console.log("hist length after splice", histObj.length);
                            }

                            if (done) {
                                if (i > 1) {
                                    histObj.data.splice(0, i - 1);
                                    stripped = true;
                                }
                                break;
                            }

                        }
                        /* if (!stripped) {
                            histObj.data.splice(0, histObj.data.length - 1);
                            histObj.data[0][0] = timeStart;
                        } */
                    }
                    histObj.lastTimeSlice = lastTimeSlice;
                    fulfill(histObj);
                } catch (ex) {
                    reject(ex);
                }
            });
        });
    };

    this.addNotificationListener = function (notificationListener) {
        _notificationListeners.add(notificationListener);
    };

    this.removeNotificationListener = function (notificationListener) {
        _notificationListeners.delete(notificationListener);
    };

    _socket.on("notification", function (notification) {
        console.log("notification", notification);
        for (let listener of _notificationListeners) {
            if (listener != null) {
                listener.newNotification(notification);
            }
        }
    });

    _socket.on("notificationUpdated", function (notification) {
        console.log("notificationUpdated", notification);

        for (let listener of _notificationListeners) {
            if (listener != null) {
                listener.updatedNotification(notification);
            }
        }
    });


    this.DS = _ds;
}

let _instance = new Push();

export { READ, WRITE, SWITCHON, SWITCHOFF, _instance as Om7Sense };



